module.exports = __webpack_public_path__ + "img/s00145.ba9cbc58.png";